export const ShuffleTraitRarities = {
  Common: 'Common',
  Uncommon: 'Uncommon',
  Rare: 'Rare',
  UltraRare: 'Ultra Rare',
};

export const shuffleTraitRarityPercentages = {
  [ShuffleTraitRarities.Common]: 70,
  [ShuffleTraitRarities.Uncommon]: 20,
  [ShuffleTraitRarities.Rare]: 8,
  [ShuffleTraitRarities.UltraRare]: 2,
};

const organizedTraits = {
  Fur: {
    [ShuffleTraitRarities.Common]: [],
    [ShuffleTraitRarities.Uncommon]: [],
    [ShuffleTraitRarities.Rare]: [],
    [ShuffleTraitRarities.UltraRare]: [],
  },
  Clothing: {
    [ShuffleTraitRarities.Common]: ['Track Suit - 230', 'Track Suit - 420', 'Track Suit - Black', 'Track Suit - Blue', 'Track Suit - Red'],
    [ShuffleTraitRarities.Uncommon]: ['Cow Suit', 'Crayon Belt'],
    [ShuffleTraitRarities.Rare]: ['Snake', 'Blueberry Suit'],
    [ShuffleTraitRarities.UltraRare]: ['Chest Burster'],
  },
  Accessory: {
    [ShuffleTraitRarities.Common]: ['Snowman'],
    [ShuffleTraitRarities.Uncommon]: [],
    [ShuffleTraitRarities.Rare]: [],
    [ShuffleTraitRarities.UltraRare]: [],
  },
  Head: {
    [ShuffleTraitRarities.Common]: ['Dazed', 'Messy Purple Wig'],
    [ShuffleTraitRarities.Uncommon]: ['Golden Medallion', 'Blueberry Beret'],
    [ShuffleTraitRarities.Rare]: [],
    [ShuffleTraitRarities.UltraRare]: ['Shark Hat'],
  },
};

const formatTrait = (trait, rarity) => ({
  name: trait,
  rarity,
});

export const shuffleTraits = {
  Fur: Object.entries(organizedTraits.Fur).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Clothing: Object.entries(organizedTraits.Clothing).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Accessory: Object.entries(organizedTraits.Accessory).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Head: Object.entries(organizedTraits.Head).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
};
